/// <reference path="../../../typings/browser.d.ts" />
/// <reference path="../../../customtypings/selectize/selectize.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ISimPlanModalScope extends ng.IScope {
        title: string;
        plan: Models.ISimPlan;
        selectedPlanType: string;
        selectedDataUnit: string;
        modalClose: () => void;
        modalSave: () => void;
        loadSelectize: () => void;
    }

    /**
     * SimPlanModalController class
     */
    export class SimPlanModalController {
        public static templateURL: string = "decorators/modals/sim-plan-modal.html";
        public static ID: string = "#id-sim-plan-modal";
        public static $name: string = "simPlanModalController";
        public static $inject: string[] = ['$scope', 'close', 'title', 'plan', '$timeout'];

        private scope: ISimPlanModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private $timeout: ng.ITimeoutService;

        private selectizeForPlanType: Selectize.IApi<string, string>;
        private selectizeForDataUnit: Selectize.IApi<string, string>;
        private planTypeOptions: Common.ISelectizeStringString[] =
            [{
                value: 'PREPAID',
                string: 'Prepaid',
            }, {
                value: 'POSTPAID',
                string: 'Postpaid',
            }, {
                value: 'UNKNOWN',
                string: 'Unknown',
            }];
        private dataUnitOptions: Common.ISelectizeStringString[] =
            [{
                value: 'MB',
                string: 'MB',
            }, {
                value: 'GB',
                string: 'GB',
            }];
        /**
         * Constructor
         */
        constructor($scope: ISimPlanModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    title: string,
                    plan: Models.ISimPlan,
                    $timeout: ng.ITimeoutService) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.scope = $scope;
            this.scope.title = title;
            this.scope.plan = plan;
            this.scope.selectedPlanType = plan.type.toString();
            this.close = close;
            this.$timeout = $timeout;

            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.modalSave = (): void => {
                if (plan.name !== undefined && plan.name !== "" &&
                    plan.operatorName !== undefined && plan.operatorName !== "" &&
                    plan.operatorCountry !== undefined && plan.operatorCountry !== "" && plan.operatorCountry.length === 2 &&
                    plan.dataAmount !== undefined && plan.dataAmount >= 0) {

                    // upper casing country code
                    plan.operatorCountry = plan.operatorCountry.toUpperCase();

                    // selected plan type
                    plan.type = this.scope.selectedPlanType;

                    // data amount must be store as bytes
                    if (this.scope.selectedDataUnit === 'GB')
                        plan.dataAmount *= 1024 * 1024 * 1024;
                    else if (this.scope.selectedDataUnit === 'MB')
                        plan.dataAmount *= 1024 * 1024;
                    plan.dataAmount = Math.round(plan.dataAmount);

                    this.close(plan);
                }
            };

            this.scope.loadSelectize = (): void => {
                this.loadSelectizeForPlanType();
                this.loadSelectizeForDataUnit();
            };
        }

        private loadSelectizeForPlanType(): void {
            if (this.scope.plan.type !== '')
                this.scope.plan.type = this.scope.selectedPlanType;
            else
                this.scope.selectedPlanType = this.planTypeOptions[2].value; // uNKNOWN by default
            if (this.selectizeForPlanType !== undefined)
                this.selectizeForPlanType.destroy();
            let self: Controllers.SimPlanModalController = this;
            let $select: JQuery = $('#select_plan_type').selectize(
                {
                    labelField: 'string',
                    valueField: 'value',
                    maxItems: 1,
                    onChange: (planType: string): void => {
                        for (let i: number = 0; i < self.planTypeOptions.length; i++) {
                            if (self.planTypeOptions[i].value === planType)
                                self.$timeout(() => {
                                    self.scope.selectedPlanType = self.planTypeOptions[i].value;
                                });
                        }
                    },
                    options: self.planTypeOptions,
                });
            this.selectizeForPlanType = $select[0].selectize;
            if (this.scope.selectedPlanType)
                this.selectizeForPlanType.setValue(this.scope.selectedPlanType);
        }

        private loadSelectizeForDataUnit(): void {
            if (this.scope.plan.dataAmount / Math.pow(1024, 3) < 1) {
                this.scope.plan.dataAmount /= Math.pow(1024, 2);
                this.scope.selectedDataUnit = this.dataUnitOptions[0].value; // 'MB'
            } else {
                this.scope.plan.dataAmount /= Math.pow(1024, 3);
                this.scope.selectedDataUnit = this.dataUnitOptions[1].value; // 'GB'
            }

            if (this.selectizeForDataUnit !== undefined)
                this.selectizeForDataUnit.destroy();
            let self: Controllers.SimPlanModalController = this;
            let $select: JQuery = $('#select_data_unit').selectize(
                {
                    labelField: 'string',
                    valueField: 'value',
                    maxItems: 1,
                    onChange: (dataUnit: string): void => {
                        for (let i: number = 0; i < self.dataUnitOptions.length; i++) {
                            if (self.dataUnitOptions[i].value === dataUnit)
                                self.$timeout(() => {
                                    self.scope.selectedDataUnit = self.dataUnitOptions[i].value;
                                });
                        }
                    },
                    options: self.dataUnitOptions,
                });
            this.selectizeForDataUnit = $select[0].selectize;
            if (this.scope.selectedDataUnit)
                this.selectizeForDataUnit.setValue(this.scope.selectedDataUnit);
        }
    }
}
